var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_776",
    "data-name": "Group 776",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.31,
    height: 36.31,
    viewBox: "0 0 36.31 36.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M326.99,250.614h-8.5A4.4,4.4,0,0,0,314.1,255v8.5a4.4,4.4,0,0,0,4.391,4.392h8.5a4.4,4.4,0,0,0,4.392-4.392V255A4.4,4.4,0,0,0,326.99,250.614ZM322.828,264.5a5.242,5.242,0,1,1,5.242-5.242A5.248,5.248,0,0,1,322.828,264.5Zm5.548-9.589a1.248,1.248,0,1,1,1.248-1.248A1.248,1.248,0,0,1,328.375,254.908Z",
    transform: "translate(-304.585 -241.125)",
    fill: "#2979ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M324.593,242.972a18.155,18.155,0,1,0,18.154,18.154A18.155,18.155,0,0,0,324.593,242.972Zm10.642,22.379a6.4,6.4,0,0,1-6.393,6.395h-8.5a6.4,6.4,0,0,1-6.393-6.395v-8.5a6.4,6.4,0,0,1,6.393-6.393h8.5a6.4,6.4,0,0,1,6.393,6.393Z",
    transform: "translate(-306.437 -242.972)",
    fill: "#2979ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M321.782,254.868a3.358,3.358,0,1,0,3.358,3.359A3.362,3.362,0,0,0,321.782,254.868Z",
    transform: "translate(-303.54 -240.097)",
    fill: "#2979ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.bf778aa31f32e249b0704c08f83563ef.svg";
export { ForwardRef as ReactComponent };